import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface StickyFooterProps {
  onScrollToSection: (sectionId: string) => void;
}
export function StickyFooter({
  onScrollToSection
}: StickyFooterProps) {
  const {
    t
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleWaitlistClick = () => {
    onScrollToSection('waitlist');
  };
  const handleCoachClick = () => {
    onScrollToSection('ai-coach');
  };
  const handleFundClick = () => {
    onScrollToSection('community');
  };
  return <AnimatePresence data-id="element-383">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-50" data-id="element-384">
          <div className="bg-black border-t-2 border-white shadow-2xl" data-id="element-385">
            <div className="max-w-6xl mx-auto px-6 py-4" data-id="element-386">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-387">
                <div className="text-center sm:text-left" data-id="element-388">
                  <p className="text-xl font-black text-white uppercase tracking-tight" data-id="element-389">
                    {t('footer.title')}
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-390">
                    {t('footer.subtitle')}
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 items-center" data-id="element-391">
                  <button onClick={handleWaitlistClick} className="px-10 py-3 bg-white text-black font-black hover:bg-gray-200 border-2 border-white transition-all duration-200 uppercase tracking-wider text-sm rounded-full shadow-lg" data-id="element-392">
                    {t('footer.cta.waitlist')}
                  </button>
                </div>
                <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 sm:relative sm:top-0 sm:right-0 p-2 text-gray-500 hover:text-white transition-colors" aria-label="Close" data-id="element-393">
                  <XIcon className="w-5 h-5" data-id="element-394" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}